import { Theme } from "@mui/material/styles"

function menuItem(theme: Theme) {
  const { palette, borders, transitions } = theme

  const { secondary, light, dark } = palette as any
  const { borderRadius } = borders as any
  const transitionsTyped = transitions as any

  return {
    display: "flex",
    alignItems: "center",
    width: "100%",
    color: secondary.main,
    borderRadius: borderRadius.md,
    transition: transitionsTyped.create("background-color", {
      easing: transitionsTyped.easing.easeInOut,
      duration: transitionsTyped.duration.standard
    }),

    "& *": {
      transition: "color 100ms linear"
    },

    "&:not(:last-child)": {
      mb: 1
    },

    "&:hover": {
      backgroundColor: light.main,

      "& *": {
        color: dark.main
      }
    }
  }
}

export default menuItem
